export default __webpack_public_path__ + "static/media/yape.874058c2.png";